import React from 'react';

function WhyChooseItConsulting() {
  const handleTalkClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('it-services-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="why-it-consulting-section">
      <div className="container">
        {/* Centered Top Header */}
        <div className="why-it-consulting-header">
          <span className="why-it-consulting-badge">Why Choose Us</span>
          <h2 className="why-it-consulting-title">IT Consulting Agency</h2>
        </div>

        {/* 2-Column Content Layout */}
        <div className="why-it-consulting-grid">
          {/* Left Column: Image */}
          <div className="why-it-consulting-left">
            <div className="why-it-consulting-img-wrapper">
              <img
                src="/assets/images/it-service/it-img2.jpg"
                alt="IT Consulting Agency - Experts Communication"
                className="why-it-consulting-img"
              />
            </div>
          </div>

          {/* Right Column: Description & Action */}
          <div className="why-it-consulting-right">
            <p className="why-it-consulting-desc">
              Being one of the top IT companies in Pakistan, we provide more than just a service to our clients. Our IT agency has expert tech support with modern data management tools. We focus on the latest technology solutions and set ourselves apart. We invest significant time in understanding your unique business requirements. Our web development and IT company is here to bring innovation and creativity with our technology solutions, and we are among the professional IT companies in Karachi that make sure everything runs smoothly.
            </p>

            <button className="btn-why-it-talk" onClick={handleTalkClick}>
              Let's talk!
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseItConsulting;
